module.exports = __webpack_public_path__ + "img/icon_request.1b59170b.svg";